import { Modal } from '@/ui/Modal'
import { Button } from '@/ui/Button'
import { useModal } from '@/components/Modal'
import { useReassignWorkstationRoute } from '../../api/useReassignWorkstationRoute'

import styles from './ReassignWorkstationRouteModal.module.scss'

export type Props = {
    route: string
    workstation: string
}

export const ReassignWorkstationRouteModal = () => {
    const { closeModal, props } = useModal<Props>()

    const { handleReassignWorkstationRoute, isPending } = useReassignWorkstationRoute(props)

    if (!props) {
        return null
    }

    return (
        <Modal className={styles.modal} onClose={closeModal} hideCloseButton>
            <div className={styles.information}>
                <h1 className={styles.title}>Take control of route {props.route}?</h1>
                <p className={styles.description}>
                    This will add route <span>{props.route}</span> to your workstation. It will be removed from{' '}
                    <span>{props.workstation}</span> in 10 minutes.
                </p>
            </div>
            <div className={styles.footer}>
                <Button rounded variant="tertiary" onClick={closeModal}>
                    Cancel
                </Button>
                <Button rounded variant="secondary" disabled={isPending} onClick={handleReassignWorkstationRoute}>
                    Control route {props.route}
                </Button>
            </div>
        </Modal>
    )
}
